module.exports = __webpack_public_path__ + "img/ivy.058ffc56.png";